import { type CommentTypeResponse, toCommentType } from 'src/models/apis/master/masterResponse';

export type AdminCommentTypeIndexResponse = CommentTypeResponse[];

export const toAdminCommentType = toCommentType;
